// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__HvRyj","form":"styles_form__2oPCM"};